import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { MailService } from '../mail.service';
import { TUI_VALIDATION_ERRORS } from '@taiga-ui/kit';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SuccessConfirmComponent } from '../success-confirm/success-confirm.component';
import { ErrorConfirmComponent } from '../error-confirm/error-confirm.component';

@Component({
  selector: 'app-form-scuola',
  templateUrl: './form-scuola.component.html',
  styleUrls: ['./form-scuola.component.scss'],
  providers: [
    {
      provide: TUI_VALIDATION_ERRORS,
      useValue: {
        required: 'Campo obbligatorio',
        requiredTrue: 'Accetta i termini per proseguire',
        email: 'E-mail non valida'
      }
    }
  ]
})
export class FormScuolaComponent implements OnInit {
  readonly mailwingId = "99cd633d-a364-4f55-bdff-da18a81dd751"
  form = new FormGroup({
    school_name: new FormControl<string | null>(null, [Validators.required]),
    school_address: new FormControl<string | null>(null, [Validators.required]),
    email: new FormControl<string | null>(null, [Validators.required, Validators.email]),
    telefono: new FormControl<string | null>(null, [Validators.required]),
    name: new FormControl<string | null>(null, [Validators.required]),
    surname: new FormControl<string | null>(null, [Validators.required]),
    privacy: new FormControl<boolean | null>(null, [])

  })

  
  constructor(private recaptchaV3Service: ReCaptchaV3Service, private mailService: MailService, private modalService: NgbModal) { }

  ngOnInit(): void {

   
     
  }

 sendEmail() {
    this.recaptchaV3Service.execute('sendEmail').subscribe(token => {
      console.log(token)
      const formData = new FormData();
      
      formData.append("school_name", this.form.controls.school_name.value as string);
      formData.append("school_address", this.form.controls.school_address.value as string);
      formData.append("name", this.form.controls.name.value as string);
      formData.append("surname", this.form.controls.surname.value as string);
      formData.append("email", this.form.controls.email.value as string);
      formData.append("phone", this.form.controls.telefono.value as string);
      formData.append("privacy", "true");
      formData.append("g-recaptcha", token);
      formData.append("mailwing_id", this.mailwingId);

      this.mailService.inviaMail(formData).subscribe({
        next: (resp) => {
          this.modalService.dismissAll()
          this.modalService.open(SuccessConfirmComponent, {
            size: 'lg',
            modalDialogClass: 'signup-modal',
            centered: true,
            
          });
          
          
        },
        error: (error) => {
          this.modalService.dismissAll()
          this.modalService.open(ErrorConfirmComponent, {
            size: 'lg',
            modalDialogClass: 'signup-modal',
            centered: true,
            
          });
        }
      })

    })
  }
 

}
